import classNames from 'classnames';

import { Stars } from '@ui/Stars';

import s from './SellerRating.sss';

// types
type SellerRatingProps = {
  averageRating: number;
  title: string;
  className?: string;
};

export const SellerRating: React.FC<SellerRatingProps> = ({
  averageRating,
  title,
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <div className={s.title}>
      {title}
    </div>
    <div className={s.blockInfo}>
      <Stars
        readOnly={true}
        value={averageRating}
        width="24"
        height="24"
        gap={4}
      />
      <div className={s.averageRating}>{averageRating.toFixed(1)}</div>
    </div>
  </div>
);
